import React, { useEffect, useRef, useState } from 'react';
import {
  PLEDGE_CARD_EXPORT_HEIGHT,
  PLEDGE_CARD_EXPORT_WIDTH,
} from '../utils/downloadPledgeCard';

/**
 * Renders the pledge card at a fixed 720×400 layout, scaled down as one unit on narrow screens.
 * Prevents font/layout drift and keeps the photo aspect ratio intact.
 */
export default function PledgeCardViewport({ children }) {
  const viewportRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = viewportRef.current;
    if (!el) return;

    const update = () => {
      const width = el.getBoundingClientRect().width;
      if (width <= 0) {
        setScale(1);
        return;
      }
      setScale(Math.min(1, width / PLEDGE_CARD_EXPORT_WIDTH));
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(el);
    window.addEventListener('resize', update);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', update);
    };
  }, []);

  const hostHeight = PLEDGE_CARD_EXPORT_HEIGHT * scale;

  return (
    <div className="pledge-card-viewport" ref={viewportRef}>
      <div className="pledge-card-scale-host" style={{ height: hostHeight }}>
        <div
          className="pledge-card-scale-inner"
          style={{
            width: PLEDGE_CARD_EXPORT_WIDTH,
            height: PLEDGE_CARD_EXPORT_HEIGHT,
            transform: `scale(${scale})`,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
